import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientCryptoAccountRoute = createRoute({
	path: '/crypto-account',
	getParentRoute: () => clientRoute,
	component: lazyRouteComponent(
		() => import('./ClientCryptoAccountPage'),
		'ClientCryptoAccountPage',
	),
});
